import { LOGIN_COOKIE_NAME, OFFERED_LEADS_TOPUP_COOKIE_NAME } from "@/constants/utils";
import { MultupleListItem, ServiceArea } from "@/models/Common";
import { QuoteDevice, QuotePart, QuoteService } from "@/models/QuoteState";
import { funnelsUtilsServices } from "@puls/puls-general-utils";
import Cookies from "js-cookie";

const utils = { 
	getZipcode: (address = "Tel Aviv, Israel") => {
		return new Promise((resolve) => { 
			const geoCoder: google.maps.Geocoder = new google.maps.Geocoder();
			geoCoder.geocode({
				address
			}, async (res: google.maps.GeocoderResult[] | null) => {
				if (!res) return resolve('888');
				const zipcode = funnelsUtilsServices.getPostalCode(res[0].address_components ? res[0].address_components : {});
				resolve(zipcode)
			})
		})
	},
	serviceAreasDisplay: (serviceAreas: ServiceArea[], selectedAreas: Set<number>): MultupleListItem[] => {
		return serviceAreas.map((area: ServiceArea) => ({
			id: area.id,
			title: area.title,
			selected: selectedAreas.has(area.id),
			group_id: area.market_id
		}))
	},
	getQuoteDevicePrice: (quoteDevice : QuoteDevice) => {
		const services = quoteDevice.services.reduce((acc: number, next: QuoteService) => (acc + parseFloat(next.price || '0')), 0)
		const parts = quoteDevice.parts.reduce((acc: number, next: QuotePart) => (acc + parseFloat(next.price || '0')), 0)

		return services + parts;
	},
	generateOverlayModalId: (uuid: string) => {
		return `modal_${uuid}`
	},
	logout: () => {
		utils.removeUserCookies();
		window.location.href = '/login';
	},
	removeUserCookies () {
		[LOGIN_COOKIE_NAME, OFFERED_LEADS_TOPUP_COOKIE_NAME].forEach(cookie => {
			Cookies.remove(cookie);
		})
	}
}

export default utils;
